import * as actionTypes from '../actions/actionTypes'
import { updateObject } from '../utility'

const initialState = {
    subTotal:  0,
    totalPrice:  0,
    currentPrice: '',
    currentColor: '',
    currentDeliveryFee: '',
    currentDeliveryPeriod:'',
    currentQty: '',
    totalQty:0,
    error: '',
    product: null,
    products: [],
    loading: true,
    purchasing: false,
}


const setProduct = (state, action) => {
    return updateObject(state, {
        totalPrice: 0,
        currentPrice: action.product.attributes[0].product_price,
        currentColor: action.product.attributes[0].product_color,
        currentDeliveryFee: action.product.attributes[0].product_delivery_fee,
        currentDeliveryPeriod: action.product.attributes[0].product_delivery_period,
        currentQty: action.product.attributes[0].product_quantity,
        product: action.product,
        error: false,
        purchasing: false,
        loading: false
    })
}
const setCurrentState = (state, action) => {
    return updateObject(state, {
        currentPrice: action.currentPrice,
        currentDeliveryPeriod:action.currentDeliveryPeriod,
        currentDeliveryFee: action.currentDelieverFee,
        currentQty:action.currentQty
    })
}

const addProduct = (state, action) => {
    const updatedProductInfor = { [action.productType]: state.products[action.productType] + 1 }
    const updatedProducts = updateObject(state.products, updatedProductInfor)
    const updatedState = {
        products: updatedProducts,
        currentPrice: state.currentPrice + action.Price,
        building: true
    }
    return updateObject(state, updatedState)
}

const addToCart = (state, action) => {
    const updatePrd = [...state.products]
    let sum = 0, totalSum = 0, totalQty = 0, pricePerItem, sumPerItem, grandTotalPerItem
    const updatdActionProd = action.product
    const currentFee = parseInt(state.currentDeliveryFee)
    let exists = false
    let prodObject = {}
    if (updatePrd.length > 0) {
        updatePrd.map((d, i) => {
            if (d.product.id === updatdActionProd.id) {
                if (updatePrd[i].attributesId === action.attributesId) {
                    let perItemPrice = parseInt(updatePrd[i].price_per_item)
                    exists = true
                    sumPerItem = perItemPrice * action.qty
                    grandTotalPerItem = sumPerItem + currentFee

                    updatePrd[i].shipping_fee = currentFee
                    updatePrd[i].qty = action.qty
                    updatePrd[i].sub_total_price = sumPerItem
                    updatePrd[i].grand_total_price = grandTotalPerItem
                }
            }
        })
        if (!exists) {
            console.log("!exists")
            updatdActionProd.attributes.map((d, i) => {
                if (d.id === action.attributesId) {
                    pricePerItem = parseInt(d.product_price)
                    sumPerItem = pricePerItem * action.qty
                    grandTotalPerItem = sumPerItem + currentFee
                }
            })
            prodObject = {
                product: updatdActionProd,
                attributesId: action.attributesId,
                qty: action.qty,
                shipping_fee: currentFee,
                sub_total_price: parseInt(sumPerItem).toFixed(2),
                price_per_item: parseInt(pricePerItem).toFixed(2),
                grand_total_price: parseInt(grandTotalPerItem).toFixed(2)
            }
            updatePrd.push(prodObject)
        }
        updatePrd.map(d => {
            const sub_total_price = parseInt(d.sub_total_price)
            const grand_total_price = parseInt(d.grand_total_price)
            const totalqty = parseInt(d.qty)
            sum = sum + sub_total_price
            totalSum = totalSum + grand_total_price
            totalQty =  totalQty + totalqty
        })
    } else {
        updatdActionProd.attributes.map((d, i) => {
            if (d.id === action.attributesId) {
                pricePerItem = d.product_price
                sumPerItem = d.product_price * action.qty
                grandTotalPerItem = sumPerItem + currentFee
            }
        })
        totalSum = grandTotalPerItem
        prodObject = {
            product: updatdActionProd,
            attributesId: action.attributesId,
            qty: action.qty,
            shipping_fee: currentFee,
            sub_total_price: parseInt(sumPerItem).toFixed(2),
            price_per_item: parseInt(pricePerItem).toFixed(2),
            grand_total_price: parseInt(grandTotalPerItem).toFixed(2)
        }
        sum = sumPerItem
        totalSum = totalSum
        totalQty = action.qty
        updatePrd.push(prodObject)
    }

    localStorage.setItem("cartItems", JSON.stringify(updatePrd))
    localStorage.setItem('totalQty',totalQty)
    localStorage.setItem('subTotal',sum)
    localStorage.setItem('totalPrice',totalSum)
    return updateObject(state, {
        products: updatePrd,
        subTotal: sum,
        totalPrice: totalSum,
        totalQty:totalQty
    })
}

const fetchCartSuccess = (state, action) => {

    // localStorage.setItem("cartItems", JSON.stringify(updatePrd))
    // localStorage.setItem('totalQty',totalQty)
    // localStorage.setItem('subTotal',sum)
    // localStorage.setItem('totalPrice',totalSum)

    return updateObject(state, {
        loading: false,
        products: action.product.items,
        subTotal: action.product.sub_total_price,
        totalPrice: action.product.grand_total_price,
        totalQty: action.product.total_qty
        
    })
}

const removeFromCart = (state, action) => {
    const updatePrd = [...state.products]

    return updateObject(state, updatePrd);

}

const fetchProductFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REMOVE_PRODUCT: return removeFromCart(state, action)
        case actionTypes.SET_PRODUCT: return setProduct(state, action)
        case actionTypes.SET_CURRENTPRODUCTSTATE: return setCurrentState(state, action)
        case actionTypes.ADD_TO_CART: return addToCart(state, action)
        case actionTypes.ADD_PRODUCT: return addProduct(state, action)
        case actionTypes.FETCH_CART_SUCCESS: return fetchCartSuccess(state, action)
        case actionTypes.FETCH_PRODUCT_FAIL: return fetchProductFail(state, action)
        
        default: return state;
    }
};


export default reducer;

